import {tail} from 'lodash'
import {Moment} from 'moment-timezone'
import React from 'react'
import {useTranslation} from 'react-i18next'

import {useTaskRepetitionPreview} from '../../hooks/useTaskRepetitionPreview'
import {TaskRepetition} from '../../types'
import {getTranslationKey} from '../../utils/translation.utils'

import {TaskRepetitionPreview} from './TaskRepetitionPreview'

type Props = {
  settings: TaskRepetition
  defaultStartDate?: Moment
  omitFirstOccurrence?: boolean
  plantId: string
  timezone: string
  translationPrefix?: string
  /** namespace holding the repetition keys; defaults to the app's default bundle */
  namespace?: string
}

export const TaskRepetitionLabel: React.FC<Props> = ({
  settings,
  defaultStartDate,
  omitFirstOccurrence,
  plantId,
  timezone,
  translationPrefix,
  namespace
}) => {
  const {t} = useTranslation(namespace)

  const numberOfPreviewItems = 3
  const query = useTaskRepetitionPreview(
    settings,
    numberOfPreviewItems + (omitFirstOccurrence ? 2 : 1),
    plantId,
    defaultStartDate
  )

  if (!query.data) {
    return <span>{t(getTranslationKey('recurringDialog.calculating', translationPrefix))}</span>
  }

  if (query.error) {
    return <span>{t(getTranslationKey('error.general', translationPrefix))}</span>
  }

  const dates = omitFirstOccurrence ? tail(query.data) : query.data

  return (
    <TaskRepetitionPreview
      dates={dates}
      repetition={settings.repetition}
      timezone={timezone}
      weekDays={'weekDays' in settings ? settings.weekDays : undefined}
      numberOfPreviewItems={numberOfPreviewItems}
      namespace={namespace}
    />
  )
}
